<script setup lang="ts">
import { storeToRefs } from 'pinia'
import dayjs from 'dayjs'
import logo from '@/assets/logo.webp'
import { useUIStore } from '@/stores/ui'

const { isCollapsed } = storeToRefs(useUIStore())

const { mode, appVersion, buildTime } = useRuntimeConfig().public
</script>

<template>
  <div class="flex-center gap-2 border-b border-base text-4 h-16 font-bold hover:text-primary">
    <!-- <img :src="logo" animated animated-fade-in :class="{ 'w-8': isCollapsed }"> -->
    <el-tooltip :content="`v${appVersion} ${dayjs(buildTime).format('YYYY-MM-DD HH:mm:ss')}`">
      <div v-if="isCollapsed">
        驾
      </div>
      <div v-else>
        驾考管理后台
      </div>
    </el-tooltip>
    <div v-if="mode !== 'production'" text-2 text-second>
      .{{ mode.slice(0, 3) }}
    </div>
  </div>
</template>
